module.exports = __webpack_public_path__ + "js/1.161799b9.worker.js"